import LoadingSVG from '../../../assets/media/svg/loading.svg';
import { __ } from "@wordpress/i18n";

const classNames = require('classnames');

const DEFAULT_LOADING_MESSAGE = __("Estamos a preparar a sua simulação.", "df-simulators");

const Loading = ({ isFull, message = DEFAULT_LOADING_MESSAGE, overlay }) => {

    const loadingClass = classNames({
        'loading-wrapper': true,
        full: isFull,
        absolute: overlay,
    });


    return <div className={loadingClass}>
        <LoadingSVG />
        {message && <div>{message}</div>}
    </div>;

};


export default Loading;
